import type { SideMenuContentProps } from '@halo/ui-react';
import { SideMenuContent } from '@halo/ui-react';
import type { ReactNode } from 'react';

interface ChatListProps extends SideMenuContentProps {
  children: ReactNode;
}

function ChatList({ children, ...props }: ChatListProps) {
  return (
    <SideMenuContent className="SidebarBody scrollHover" as="section" flex="auto" {...props}>
      {children}
    </SideMenuContent>
  );
}

const MemoizedChatList = memo(ChatList);

export { MemoizedChatList as ChatList };
